import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import AppLayout from "@/components/layout/AppLayout";
import CommandCenter from "@/pages/CommandCenter";
import NewPairs from "@/pages/NewPairs";
import BreakoutRadar from "@/pages/BreakoutRadar";
import NarrativeRadar from "@/pages/NarrativeRadar";
import TokenResearch from "@/pages/TokenResearch";
import WalletIntelligence from "@/pages/WalletIntelligence";
import WalletProfile from "@/pages/WalletProfile";
import WalletTracker from "@/pages/WalletTracker";
import DevTracker from "@/pages/DevTracker";
import DevProfile from "@/pages/DevProfile";
import Watchlists from "@/pages/Watchlists";
import Alerts from "@/pages/Alerts";
import HistoricalAnalytics from "@/pages/HistoricalAnalytics";
import BacktestLab from "@/pages/BacktestLab";
import MarketOverview from "@/pages/MarketOverview";
import Settings from "@/pages/Settings";

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<AppLayout />}>
            <Route path="/" element={<CommandCenter />} />
            <Route path="/new-pairs" element={<NewPairs />} />
            <Route path="/breakout-radar" element={<BreakoutRadar />} />
            <Route path="/narrative-radar" element={<NarrativeRadar />} />
            <Route path="/token/:id" element={<TokenResearch />} />
            <Route path="/wallets" element={<WalletIntelligence />} />
            <Route path="/wallet/:address" element={<WalletProfile />} />
            <Route path="/wallet-tracker" element={<WalletTracker />} />
            <Route path="/dev-tracker" element={<DevTracker />} />
            <Route path="/developer/:address" element={<DevProfile />} />
            <Route path="/watchlists" element={<Watchlists />} />
            <Route path="/alerts" element={<Alerts />} />
            <Route path="/historical-analytics" element={<HistoricalAnalytics />} />
            <Route path="/backtest-lab" element={<BacktestLab />} />
            <Route path="/market-overview" element={<MarketOverview />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" richColors />
    </div>
  );
}

export default App;
